var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('g',[_c('polygon',{attrs:{"points":"14.36 18.35 14.36 4.07 17.9 4.1 17.9 19.96 14.36 18.35"}}),_c('polygon',{attrs:{"points":"5.95 18.35 5.95 4.07 9.49 4.1 9.49 19.96 5.95 18.35"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }